export function isGutenbergEditorVisible() {
    return document.body.classList.contains('block-editor-iframe__body')
}